import React from 'react';
import { formatMarathiDate } from '../../utils/marathi';
import './DetailModal.css';

export default function DepartmentDetailModal({ department, onClose }) {
  if (!department) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <div>
            <h2>{department.name}</h2>
            {department.name_marathi && <p style={{ margin: '5px 0 0 0', color: '#666', fontSize: '14px' }}>{department.name_marathi}</p>}
          </div>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>

        <div className="modal-body">
          {/* Basic Information */}
          <div className="modal-section">
            <h3>मूलभूत माहिती (Basic Information)</h3>
            <div className="detail-grid">
              <div className="detail-item">
                <label>Type:</label>
                <span>{department.department_type}</span>
              </div>
              <div className="detail-item">
                <label>Status:</label>
                <span className={department.is_active ? 'status-active' : 'status-inactive'}>
                  {department.is_active ? 'Active' : 'Inactive'}
                </span>
              </div>
            </div>
            {department.description && (
              <div className="detail-item full-width">
                <label>Description:</label>
                <p>{department.description}</p>
              </div>
            )}
          </div>

          {/* Department Head Information */}
          {(department.head_name || department.head_designation || department.head_phone || department.head_email) && (
            <div className="modal-section">
              <h3>विभाग प्रमुख (Department Head)</h3>
              <div className="detail-grid">
                {department.head_name && (
                  <div className="detail-item">
                    <label>Name:</label>
                    <span>{department.head_name}</span>
                  </div>
                )}
                {department.head_designation && (
                  <div className="detail-item">
                    <label>Designation:</label>
                    <span>{department.head_designation}</span>
                  </div>
                )}
                {department.head_phone && (
                  <div className="detail-item">
                    <label>Phone:</label>
                    <span>{department.head_phone}</span>
                  </div>
                )}
                {department.head_email && (
                  <div className="detail-item">
                    <label>Email:</label>
                    <span>{department.head_email}</span>
                  </div>
                )}
              </div>
            </div>
          )}

          {/* Office Information */}
          {(department.office_phone || department.office_email || department.office_location || department.office_address || department.working_hours) && (
            <div className="modal-section">
              <h3>कार्यालय माहिती (Office Information)</h3>
              <div className="detail-grid">
                {department.office_phone && (
                  <div className="detail-item">
                    <label>Phone:</label>
                    <span>{department.office_phone}</span>
                  </div>
                )}
                {department.office_email && (
                  <div className="detail-item">
                    <label>Email:</label>
                    <span>{department.office_email}</span>
                  </div>
                )}
                {department.office_location && (
                  <div className="detail-item">
                    <label>Location:</label>
                    <span>{department.office_location}</span>
                  </div>
                )}
                {department.working_hours && (
                  <div className="detail-item">
                    <label>Working Hours:</label>
                    <span>{department.working_hours}</span>
                  </div>
                )}
              </div>
              {department.office_address && (
                <div className="detail-item full-width">
                  <label>Address:</label>
                  <p>{department.office_address}</p>
                </div>
              )}
            </div>
          )}

          {/* Services Information */}
          {department.services_offered && (
            <div className="modal-section">
              <h3>सेवा (Services Offered)</h3>
              <div className="detail-item full-width">
                <p>{department.services_offered}</p>
              </div>
            </div>
          )}

          {/* Documents Required */}
          {department.documents_required && department.documents_required.length > 0 && (
            <div className="modal-section">
              <h3>आवश्यक कागदपत्रे (Required Documents)</h3>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                {department.documents_required.map((doc) => (
                  <span
                    key={doc}
                    style={{
                      padding: '6px 12px',
                      backgroundColor: '#e3f2fd',
                      color: '#1976d2',
                      borderRadius: '20px',
                      fontSize: '12px',
                      fontWeight: '600',
                    }}
                  >
                    ✓ {doc}
                  </span>
                ))}
              </div>
            </div>
          )}

          {/* Metadata */}
          <div className="modal-section">
            <h3>माहिती (Metadata)</h3>
            <div className="detail-grid">
              <div className="detail-item">
                <label>Created:</label>
                <span>{formatMarathiDate(department.created_at)}</span>
              </div>
              <div className="detail-item">
                <label>Updated:</label>
                <span>{formatMarathiDate(department.updated_at)}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <button className="btn-secondary" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
}
